import { useMemo } from "react";
import { SWRConfiguration, SWRResponse } from "swr";

import { GetSubSpecies, GetSubSpeciesResponse } from "../../api/dtos/dtos";
import useGet from "../api/useGet";


const getData = (response?: SWRResponse<GetSubSpeciesResponse, GetSubSpeciesResponse>) => response?.data?.subSpecies;
const getError = (response?: SWRResponse<GetSubSpeciesResponse, GetSubSpeciesResponse>) => (response?.error ?? response?.data)?.responseStatus;
const getAdditionalState = (_?: SWRResponse<GetSubSpeciesResponse, GetSubSpeciesResponse>) => ({});

const useGetSubSpecies = (query?: Partial<GetSubSpecies>, configuration?: SWRConfiguration) => {
    const request = useMemo(() => {
        if (!query) {
            return undefined;
        }

        return () => {
            return new GetSubSpecies(query);
        }
    }, [query]);

    return useGet(request, { getData, getError, getAdditionalState }, configuration);
}

export default useGetSubSpecies;